import React, { useEffect, useRef, useState } from 'react';
import AppSearchBar from '@projectK/components/AppSearchBar';
import { useAuthUser } from '@projectK/hooks/AuthHooks';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import AppTableContainer from '@projectK/components/AppTableContainer';
import TableHeading from './TableHeading';
import TableItem from './TableItem';
import { useIntl } from 'react-intl';
import { Box, Typography } from '@mui/material';
import jwtAxios from '@projectK/services/auth/JWT';
import AppsPagination from '@projectK/components/AppsPagination';
import CompanyTheme from '@projectK/constants/CompanyTheme';
import { Fonts } from '@projectK/constants';
import AppCard from '@projectK/components/AppCard';
import PropTypes from 'prop-types';

const AccountMerging = ({ fetchMembers }) => {
  const companyTheme = CompanyTheme();
  const { user } = useAuthUser();
  const [mergeAccounts, setMergeAccounts] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(0);
  const [search, setSearch] = useState('');
  const perPage = 5;

  const abortControllerRef = useRef(null);
  useEffect(() => {
    fetchMembersData();
    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, [search, page, perPage]);

  const fetchMembersData = async () => {
    abortControllerRef.current = new AbortController();
    const { signal } = abortControllerRef.current;
    try {
      const response = await jwtAxios.get(`/merge-accounts`, {
        params: {
          search: search,
          page: page,
          perPage: perPage,
          parentId: user.id,
        },
        signal,
      });
      const { data } = response;
      setMergeAccounts(data.list);
      setTotal(response.data.total);
    } catch (error) {
      setMergeAccounts([]);
    }
  };
  const onPageChange = (event, value) => {
    setPage(value);
  };

  const onSearchOrder = (value) => {
    setSearch(value);
    setPage(0);
  };

  const { messages } = useIntl();
  return (
    <AppCard>
      <Typography
        component='h3'
        sx={{
          marginBottom: 2,
          fontSize: 16,
          fontWeight: Fonts.BOLD,
          color: companyTheme ? companyTheme.primary.main : 'text.primary',
        }}
      >
        Merge Accounts
      </Typography>
      <Box
        display='flex'
        flexDirection='row'
        alignItems='center'
        width={1}
        justifyContent='space-between'
        marginBottom={5}
      >
        <AppSearchBar
          iconPosition='right'
          overlap={false}
          onChange={(event) => onSearchOrder(event.target.value)}
          placeholder={messages['common.searchHere']}
        />

        <Box display='flex' flexDirection='row' alignItems='center'>
          <AppsPagination
            rowsPerPage={perPage}
            count={total}
            page={page}
            onPageChange={onPageChange}
          />
        </Box>
      </Box>
      <AppTableContainer>
        <Table className='table'>
          <TableHead>
            <TableHeading user={user} />
          </TableHead>
          <TableBody>
            {mergeAccounts?.map((item, index) => (
              <TableItem key={item.id} data={item} />
            ))}
          </TableBody>
        </Table>
      </AppTableContainer>
    </AppCard>
  );
};

AccountMerging.propTypes = {
  fetchMembers: PropTypes.func,
};
export default AccountMerging;
